export enum MessageInfoVariant {
  Default = 'Default',
  Success = 'Success',
  Ai = 'Ai',
  Danger = 'Danger',
}

export type MessageInfoProps = {
  className?: string;
  message: React.ReactNode;
  onRequestClose?: () => void;
  variant?: MessageInfoVariant;
};

export type MessageInfoStyleProps = {
  variant: MessageInfoVariant;
};
